import { render, staticRenderFns } from "./DialogFooter.vue?vue&type=template&id=100993ee&"
import script from "./DialogFooter.vue?vue&type=script&lang=ts&"
export * from "./DialogFooter.vue?vue&type=script&lang=ts&"
import style0 from "./DialogFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports